import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link,useParams } from "react-router-dom";
import PlaceholderImage from '../../../assest/images/no-img.jpg';
import { useSelector } from 'react-redux';
import { getblogDetailListFormData } from '../../../services/routes.services';
import constants from '../../../services/constants';
import LoginPopup from "../../Common/Login/UserLogin";

const ViewPostListingPage = () => {
  const [jobData, setJobData] = useState([]);
  const [loginShow, setLoginShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { isAuthenticated, token } = useSelector((state) => state.auth);

  const loginCloseHandler = () => setLoginShow(false);
const { url } = useParams(); // Extract `id` from the URL
 console.log(url)
  useEffect(() => {
    if (!isAuthenticated) {
      setLoginShow(true);
    } else {
      setLoading(true);
      getblogDetailListFormData(token,url)
        .then((res) => {
          setJobData(res.data.blog);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setError('Failed to load posts.');
          setLoading(false);
        });
    }
  }, [isAuthenticated, token]);

  if (!isAuthenticated) {
    return loginShow && <LoginPopup onClose={loginCloseHandler} />;
  }



  return (
    <div>
      <section className={`${Style.clear} ${Style.breadcrumb}`}>
        <Container>
          <Row>
            <Col>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/community">Community</Link></li>
                <li><Link to="/view-posts-listing">Posts</Link></li>
                <li>View Post Detail</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <div className={`${Style.pageTitle} ${Style.marginUp90}`}>
        <Container>
          <Row>
            <Col>
              <div className={Style.sectionTitle}>
                <h2>Posts</h2>
              </div>
            </Col>
          </Row>
      
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>{error}</p>
          ) : (
            <Row>
              {/* {currentData.map((post) => ( */}
                <Col  md={12}>
                  <div className={Style.offerElement}>
                    <figure className={Style.PostDetailImage}>
                      <img
                      // src="https://mayoapi.mayoalumni.in/upload/post/vidushi%20gulati.jpeg"
                        src={jobData?.image ? `${constants.IMAGE_BASE_URL}blog/${jobData.image}` : PlaceholderImage}
                        alt={jobData?.title || 'Post Image'}
                      />
                    </figure>
                    <div className={Style.offerTitle}>
                      <h5>{jobData?.title}</h5>
                      <p>{jobData?.description}</p>
                      <table className={Style.postdatatable} role="none">
                          <tbody><tr>
                              <td >Posted By :- {jobData?.user?.name} {jobData?.user?.last} </td>
                          </tr>
                          <tr>
                              <td >Batch :- {jobData?.user?.batch} </td>
                          </tr>
                      </tbody></table>
                    </div>
                    
                  </div>
                </Col>
              {/* ))} */}
              
            </Row>
          )}
        </Container>
      </div>
    </div>
  );
};

export default ViewPostListingPage;
